import lazyWithRetry from 'tools/lazyWithRetry';

const BillableCreditToValidateListPage = lazyWithRetry(() => import(
	/* webpackChunkName: "billableCreditToValidateListPage" */
	'../../pages/Billable/BillableCreditToValidateListPage'));

const BillableInvoiceToValidateListPage = lazyWithRetry(() => import(
	/* webpackChunkName: "billableInvoiceToValidateListPage" */
	'../../pages/Billable/BillableInvoiceToValidateListPage'));

const BillableListPage = lazyWithRetry(() => import(
	/* webpackChunkName: "BillableListPage" */
	'../../pages/Billable/BillableListPage/BillableListPage'));

const BillableDashboardPage = lazyWithRetry(() => import(
	/* webpackChunkName: "billableDashboardPage" */
	'../../pages/Billable/BillableDashboardPage/BillableDashboardPage'));


export default [
	{
		component: BillableCreditToValidateListPage,
		exact: true,
		path: '/billables/refunds',
	},
	{
		component: BillableInvoiceToValidateListPage,
		exact: true,
		path: '/billables/invoices',
	},
	{
		component: BillableListPage,
		exact: true,
		path: '/to_edit_billables',
	},
	{
		component: BillableDashboardPage,
		exact: true,
		path: '/billables/:billableId',
	},
];
